import React, { Fragment, useContext, useEffect, useState } from "react";

import { getTokenData } from "../../../../services/Auth__Service";
import { PARAMS_NUMBERS } from "../../../../services/config";
import { allStatClient } from "../../../../services/Statistique__Service";
import navContext from "../../../Context/navContext";
import notifyContext from "../../../Context/notifyContext";
import Loader from "../../../Loader/Loader";
import NumericLabel from "react-pretty-numbers";
import { findOneByLogin } from "../../../../services/User__Service";
import { FaFileArchive } from "react-icons/fa";
import { Link } from "react-router-dom";
import ListSalarieForOneClient from "../ListSalarieForOneClient/ListSalarieForOneClient";
import Modal from "../../../Modal/Modal";
import FormFileWithSalarie from "../File/FormFileWithSalarie/FormFileWithSalarie";

const DashBoardMain = () => {
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const [stat, setStat] = useState({
    countSalarie: 0,
    countDocument: 0,
    countUser: 0,
    countDocumentArchivied: 0,
    countSimulation: 0,
    countSimulationNotHasResponse: 0,
    countSimulationHasReponse: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [clientId, setClientId] = useState(0);
  const [viewAddDocRH, setViewAddDocRH] = useState(false);

  useEffect(() => {
    const data = getTokenData();
    setClientId(data.user_id);

    nav({
      links: [
        {
          href: "/client/dashboard",
          linkname: "Accueil",
        },
      ],
      children: "",
    });
    fetchAllStatistique(data.user_id);
    fetchOneUSerByLogin(data.login);
  }, []);

  const fetchAllStatistique = async (id) => {
    allStatClient(id)
      .then((response) => {
        setStat(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const fetchOneUSerByLogin = async (login) => {
    findOneByLogin(login).then((response) => {
      setUser(response.data);
    });
  };

  return (
    <Fragment>
      <div className="dashboard main">
        <div className="dashboard__header">
          <div>
            <h3 className="dashboard__salutation">
              <p>Bienvenue {user !== null ? user.fullname : null}</p>
            </h3>

            <div className="cta">
              <Link className="btn" to="/client/simulation/new">
                Nouvelle simulation
              </Link>
              <button className="btn" onClick={() => setViewAddDocRH(true)}>
                Nouveau doc. RH
              </button>
            </div>
          </div>
          <div className="simulation-stats">
            <p className="simulation-stats__title">Simulations</p>
            <p>
              Envoyé (s) :
              <strong>
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countSimulation}
                </NumericLabel>
              </strong>
            </p>
            <p>
              En attente :{" "}
              <strong>
                {" "}
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countSimulationNotHasResponse}
                </NumericLabel>
              </strong>
            </p>
          </div>
        </div>
        <div className="dashboard__body">
          <div className="dashboard__stats">
            <div className="stat">
              <h1 className="stat__count">
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countSalarie}
                </NumericLabel>
              </h1>
              <h4 className="stat__title">Total Salariés</h4>
              <Link className="stat__link" to="/client/salarie">
                Afficher
              </Link>
            </div>
            <div className="stat">
              <h1 className="stat__count">
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countDocument}
                </NumericLabel>
              </h1>
              <h4 className="stat__title">Total Bulletins</h4>
              <Link className="stat__link" to="/client/document">
                Afficher
              </Link>
            </div>
            <div className="stat">
              <h1 className="stat__count">
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countUser}
                </NumericLabel>
              </h1>
              <h4 className="stat__title">Total Gestionnaires</h4>
              <Link className="stat__link" to="/client/users">
                Afficher
              </Link>
            </div>
            <div className="stat">
              <h1 className="stat__count">
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countSimulation}
                </NumericLabel>
              </h1>
              <h4 className="stat__title">Total Simulations</h4>
              <Link className="stat__link" to="/client/simulation">
                Afficher
              </Link>
            </div>
          </div>
          <div className="dashboard__list">
            <ListSalarieForOneClient clientId={clientId} />
          </div>
        </div>
      </div>
      {isLoading && <Loader loadingMsg="Chargement en cours" />}

      {viewAddDocRH && (
        <Modal>
          <div className={`modal`}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Document</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewAddDocRH(false)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormFileWithSalarie setViewAddDocRH={setViewAddDocRH} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewAddDocRH(false)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default DashBoardMain;
